<div class="ai-agent-access">
  <span class="ai-agent-access__icon">
    <sim-icon icon="lock" [sizeInPx]="26" />
  </span>
  <div class="ai-agent-access__texts">
    <h2 class="ai-agent-access__title">{{ texts.title }}</h2>
    <p class="ai-agent-access__description">{{ texts.description }}</p>
  </div>
  <div class="ai-agent-access__actions">
    <a class="ai-agent-access__mail" [href]="mailto()">
      <sim-icon icon="mail" [sizeInPx]="18" />
      <ng-container i18n="@@AI_AGENT_EMAIL_SIMLAB">Email Simlab</ng-container>
    </a>
    <button
      type="button"
      id="ai-agent-access-check-again"
      class="ai-agent-access__check"
      [disabled]="checking()"
      (click)="onCheckAgain()"
    >
      <sim-icon icon="refresh" [sizeInPx]="16" />
      <ng-container i18n="@@AI_AGENT_CHECK_AGAIN">Check again</ng-container>
    </button>
    @if (userEmail(); as email) {
      <p class="ai-agent-access__signed-in">
        <ng-container i18n="@@AI_AGENT_SIGNED_IN_AS">Signed in as</ng-container> {{ email }}
      </p>
    }
  </div>
</div>
